import { render, staticRenderFns } from "./addSubProduct.vue?vue&type=template&id=491f1cf7&"
import script from "./addSubProduct.vue?vue&type=script&lang=js&"
export * from "./addSubProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports